import * as Events from 'src/app/_contstants/pusher-contstants';
import { IChannel } from 'src/app/Shared/_models/channel.model';

const publicChannels: IChannel[] = [
  {
    channelName: Events.PUBLIC_CHANNEL,
    events: [
      {
        eventName: Events.AUCTION_UPDATED,
        showNot: true,
        pushTitle: 'Auction Update',
      },
    ],
  },
];
const privateChannels: IChannel[] = [
  {
    channelName: Events.PRIVATE_USER_ID,
    events: [
      {
        eventName: Events.TERMS_CONDITIONS_UPDATE,
        showNot: true,
        pushTitle: 'Terms Changed',
      },

      {
        eventName: Events.BUYER_APP_ACCEPTED,
        showNot: true,
        pushTitle: 'Status Update',
      },

      {
        eventName: Events.BUYER_APP_REJECTED,
        showNot: true,
        pushTitle: 'Status Update',
      },
    ],
  },
];

export function getAuctionChannels(user_id: any) {
  let channels = [...publicChannels];
  if (user_id) {
    channels = [
      ...channels,
      ...updateUserIdInChannels(privateChannels, user_id.toString()),
    ];
  }
  return channels;
}
const updateUserIdInChannels = (
  channels: IChannel[],
  userId: string
): IChannel[] => {
  return channels.map((channel) => ({
    ...channel,
    channelName: channel.channelName.replace('USERID', userId),
  }));
};
